<select #langSelect (change)="changeLanguage(langSelect.value)" style="margin: 0 auto;display: block;">
    <option  value="fr" [selected]="currentLang === 'fr' ">{{'langue_fr' | translate}}</option>
    <option  value="en" [selected]="currentLang === 'en' ">{{'langue_en' | translate}}</option>
  </select>